__turbopack_context__.v({
  "agentHead": "pages-module__x6ka4q__agentHead",
  "agentId": "pages-module__x6ka4q__agentId",
  "asidePanel": "pages-module__x6ka4q__asidePanel",
  "backLink": "pages-module__x6ka4q__backLink",
  "backRow": "pages-module__x6ka4q__backRow",
  "barFill": "pages-module__x6ka4q__barFill",
  "barTrack": "pages-module__x6ka4q__barTrack",
  "block": "pages-module__x6ka4q__block",
  "blockLabel": "pages-module__x6ka4q__blockLabel",
  "cardCol": "pages-module__x6ka4q__cardCol",
  "cardText": "pages-module__x6ka4q__cardText",
  "cardTitle": "pages-module__x6ka4q__cardTitle",
  "cardTop": "pages-module__x6ka4q__cardTop",
  "channelHint": "pages-module__x6ka4q__channelHint",
  "clamp2": "pages-module__x6ka4q__clamp2",
  "compHead": "pages-module__x6ka4q__compHead",
  "compItem": "pages-module__x6ka4q__compItem",
  "compList": "pages-module__x6ka4q__compList",
  "compPanel": "pages-module__x6ka4q__compPanel",
  "detail": "pages-module__x6ka4q__detail",
  "detailAside": "pages-module__x6ka4q__detailAside",
  "domainCard": "pages-module__x6ka4q__domainCard",
  "domainColumns": "pages-module__x6ka4q__domainColumns",
  "extLink": "pages-module__x6ka4q__extLink",
  "footNote": "pages-module__x6ka4q__footNote",
  "header": "pages-module__x6ka4q__header",
  "headerLabel": "pages-module__x6ka4q__headerLabel",
  "honestyNote": "pages-module__x6ka4q__honestyNote",
  "kv": "pages-module__x6ka4q__kv",
  "linkList": "pages-module__x6ka4q__linkList",
  "list": "pages-module__x6ka4q__list",
  "lost": "pages-module__x6ka4q__lost",
  "lostCode": "pages-module__x6ka4q__lostCode",
  "metaBlock": "pages-module__x6ka4q__metaBlock",
  "nodeLabel": "pages-module__x6ka4q__nodeLabel",
  "nodeRow": "pages-module__x6ka4q__nodeRow",
  "principle": "pages-module__x6ka4q__principle",
  "principleIndex": "pages-module__x6ka4q__principleIndex",
  "principles": "pages-module__x6ka4q__principles",
  "roleLabel": "pages-module__x6ka4q__roleLabel",
  "routeIntent": "pages-module__x6ka4q__routeIntent",
  "routeRow": "pages-module__x6ka4q__routeRow",
  "routeTo": "pages-module__x6ka4q__routeTo",
  "routing": "pages-module__x6ka4q__routing",
  "section": "pages-module__x6ka4q__section",
  "sectionHead": "pages-module__x6ka4q__sectionHead",
  "sectionHeadMeta": "pages-module__x6ka4q__sectionHeadMeta",
  "simPanel": "pages-module__x6ka4q__simPanel",
  "simTag": "pages-module__x6ka4q__simTag",
  "stateTag": "pages-module__x6ka4q__stateTag",
  "tagRow": "pages-module__x6ka4q__tagRow",
  "tile": "pages-module__x6ka4q__tile",
  "tileNote": "pages-module__x6ka4q__tileNote",
  "tileValue": "pages-module__x6ka4q__tileValue",
  "tiles": "pages-module__x6ka4q__tiles",
  "tree": "pages-module__x6ka4q__tree",
});
